{
  "login": {
    "title": "Iniciar sesión",
    "emailLabel": "Dirección de correo electrónico",
    "passwordLabel": "Contraseña",
    "rememberMe": "Recordarme durante 30 días",
    "submitButton": "Iniciar sesión",
    "submittingButton": "Iniciando sesión...",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "setNewPassword": "Establece una nueva contraseña aquí",
    "sessionExpired": "Sesión expirada",
    "noAccountYet": "¿Aún no tienes cuenta?",
    "createOne": "Crea una"
  },
  "forgotPassword": {
    "title": "Contraseña olvidada",
    "emailLabel": "Dirección de correo electrónico",
    "submitButton": "Enviar enlace para restablecer contraseña a tu correo",
    "backToLogin": "Regresar al inicio de sesión",
    "submittingButton": "Enviando...",
    "successTitle": "Revisa tu bandeja de entrada",
    "successMessage": "Si existe una cuenta con esta dirección, te enviamos un enlace de restablecimiento por correo."
  },
  "confirmEmail": {
    "confirming": "Confirmando tu correo electrónico…",
    "successTitle": "Correo confirmado",
    "successMessage": "Tu dirección de correo ha sido confirmada. Ya puedes iniciar sesión en tu cuenta.",
    "continueToLogin": "Continuar al inicio de sesión",
    "errorTitle": "Error de confirmación",
    "errorMessage": "No pudimos confirmar tu correo. Es posible que el enlace no sea válido o haya expirado."
  },
  "resetPassword": {
    "title": "Restablecer contraseña",
    "subtitle": "Ingresa tu nueva contraseña a continuación",
    "newPasswordLabel": "Nueva contraseña",
    "newPasswordPlaceholder": "Ingresa tu nueva contraseña",
    "confirmPasswordLabel": "Confirmar nueva contraseña",
    "confirmPasswordPlaceholder": "Confirma tu nueva contraseña",
    "passwordsDoNotMatch": "Las contraseñas no coinciden",
    "submitButton": "Establecer nueva contraseña",
    "submittingButton": "Restableciendo contraseña...",
    "invalidToken": "Token de restablecimiento no válido",
    "fixRequirements": "Por favor corrige los requisitos de la contraseña",
    "failedReset": "No se pudo restablecer la contraseña"
  },
  "acceptTerms": {
    "title": "Términos y condiciones",
    "subtitle": "Revisa y acepta nuestros términos para continuar",
    "welcomeTitle": "¡Bienvenido a Flipping Pal!",
    "welcomeBody": "Estos términos y condiciones describen las reglas y regulaciones para el uso del sitio web de Flipping Pal, ubicado en",
    "welcomeBody2": "Al acceder a este sitio web, asumimos que aceptas estos términos y condiciones. No continúes usando Flipping Pal si no estás de acuerdo con todos los términos y condiciones indicados en esta página.",
    "keyPointsTitle": "Puntos clave:",
    "keyPoints": {
      "0": "Flipping Pal posee todos los derechos de propiedad intelectual sobre los materiales de este sitio web",
      "1": "No puedes republicar, vender ni redistribuir contenido de Flipping Pal",
      "2": "Usamos cookies para mejorar tu experiencia en nuestro sitio web",
      "3": "Los comentarios de los usuarios no reflejan las opiniones de Flipping Pal",
      "4": "Nos reservamos el derecho de modificar estos términos en cualquier momento",
      "5": "El contenido del sitio web se proporciona \"tal cual\" sin garantías"
    },
    "responsibilitiesTitle": "Tus responsabilidades:",
    "responsibilities": {
      "0": "Usa el servicio de acuerdo con todas las leyes aplicables",
      "1": "Mantén la seguridad de las credenciales de tu cuenta",
      "2": "No intentes comprometer la seguridad de nuestros sistemas",
      "3": "Respeta los derechos de propiedad intelectual"
    },
    "previewNote": "📄 Esta es una vista previa de nuestros Términos y condiciones. Haz clic en \"Ver términos completos\" para leer el documento completo.",
    "viewFullTerms": "Ver Términos y condiciones completos (se abre en una pestaña nueva)",
    "checkboxLabel": "He leído y acepto los Términos y condiciones",
    "checkboxDescription": "Al marcar esta casilla, reconoces que has leído, comprendido y aceptas quedar vinculado por estos términos.",
    "acceptButton": "Aceptar y continuar",
    "acceptingButton": "Aceptando...",
    "questionsText": "¿Preguntas sobre nuestros términos?",
    "contactSupport": "Contactar soporte"
  },
  "discord": {
    "linkingTitle": "Vinculando cuenta de Discord",
    "linkingBody": "Por favor espera mientras conectamos tu cuenta de Discord...",
    "successTitle": "¡Éxito!",
    "successBody": "Tu cuenta de Discord ha sido vinculada correctamente.",
    "successWindowClose": "Esta ventana se cerrará automáticamente...",
    "successRedirect": "Redirigiendo a ajustes...",
    "errorTitle": "Vinculación fallida",
    "errorBody": "No pudimos vincular tu cuenta de Discord.",
    "errorWindowClose": "Esta ventana se cerrará automáticamente...",
    "errorRedirect": "Redirigiendo a ajustes...",
    "backToSettings": "Regresar a ajustes"
  },
  "register": {
    "title": "Crear cuenta",
    "subtitle": "Únete a nosotros y empieza tu aventura hoy",
    "emailLabel": "Dirección de correo electrónico",
    "emailPlaceholder": "Ingresa tu dirección de correo electrónico",
    "passwordLabel": "Contraseña",
    "passwordPlaceholder": "Crea una contraseña segura",
    "confirmPasswordLabel": "Confirmar contraseña",
    "confirmPasswordPlaceholder": "Confirma tu contraseña",
    "passwordStrength": "Seguridad de la contraseña",
    "strengthStrong": "Fuerte",
    "strengthMedium": "Media",
    "strengthWeak": "Débil",
    "termsLabel": "Acepto los",
    "termsLink": "Términos y condiciones",
    "termsLabel2": "",
    "submitButton": "Crear cuenta",
    "submittingButton": "Creando cuenta...",
    "alreadyHaveAccount": "¿Ya tienes una cuenta?",
    "signInHere": "Inicia sesión aquí",
    "registrationClosed": "Registro no disponible actualmente",
    "registrationClosedMessage": "Por el momento el registro está cerrado",
    "fixFormErrors": "Por favor corrige los errores del formulario antes de enviar",
    "acceptTermsRequired": "Por favor acepta los Términos y condiciones para continuar",
    "registrationFailed": "El registro falló. Por favor, inténtalo de nuevo."
  },
  "errorBoundary": {
    "title": "Algo salió mal",
    "subtitle": "Ocurrió un error inesperado. No te preocupes — tus datos están seguros.",
    "unknownError": "Error desconocido",
    "goHome": "Ir al inicio",
    "reloadPage": "Recargar página",
    "logout": "Cerrar sesión",
    "showErrorDetails": "Mostrar detalles del error",
    "hideErrorDetails": "Ocultar detalles del error",
    "copyToClipboard": "Copiar al portapapeles",
    "copied": "¡Copiado!",
    "copy": "Copiar",
    "errorLabel": "Error",
    "componentStackLabel": "Pila de componentes",
    "reference": "Referencia"
  }
}
